<template>
    <div class="border border-error-500 p-2 rounded-md">
        <div>
            {{ message }}
        </div>
        <div class="flex justify-between items-center">
            <span>
                {{ $formatters.datetime(alert.createdAt) }}
            </span>
            <div>
                <label class="mr-1 font-medium">
                    Thao tác:
                </label>
                <hts-form-button
                    size="small"
                    :loading="skipping"
                    @click="skipAlert">
                    {{ $t('labels.skip') }}
                </hts-form-button>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  journey: {
    type: Object,
    required: true
  },
  alert: {
    type: Object,
    required: true
  }
})
const { $dayjs, $formatters } = useNuxtApp()

const emits = defineEmits(['skipped'])
const { journey, alert } = toRefs(props)
const skipping = ref(false)
const skipAlert = () => {
  skipping.value = true
  $api($urlPartner.monitoring.alert.skip, { uriParams: { ID: journey.value._id, ALERT_ID: alert.value?._id } })
    .then((response) => {
      emits('skipped', alert.value._id)
      skipping.value = false
    })
    .catch(() => {
      skipping.value = false
    })
}

const message = computed(() => {
  let message = alert.value?.message ?? ''
  if (alert.value.data?.timeMessage) {
    Object.keys(alert.value.data?.timeMessage).forEach((key: string) => {
      const formatTime = $formatters.datetime(alert.value.data?.timeMessage[key])
      message = message.replace(`[${key}]`, formatTime)
    })
  }
  return message
})
</script>
